import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { setWarmupHandler } from "../services/warmupController";

const WarmupContext = createContext(null);
export const useWarmup = () => useContext(WarmupContext);

export const WarmupProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [remaining, setRemaining] = useState(60);
  const intervalRef = useRef(null);
  const resolverRef = useRef(null);

  const cleanupTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const hideAndResolve = () => {
    cleanupTimer();
    setVisible(false);
    const resolve = resolverRef.current;
    resolverRef.current = null;
    if (typeof resolve === "function") resolve();
  };

  const showWarmup = async ({ seconds = 60 } = {}) => {
    // If already showing, just wait for the existing one.
    if (visible && resolverRef.current) {
      await new Promise((resolve) => {
        const existing = resolverRef.current;
        resolverRef.current = () => {
          existing?.();
          resolve();
        };
      });
      return;
    }

    setRemaining(seconds);
    setVisible(true);

    await new Promise((resolve) => {
      resolverRef.current = resolve;
      cleanupTimer();
      intervalRef.current = setInterval(() => {
        setRemaining((r) => {
          if (r <= 1) {
            // Auto-resolve at 0s and hide
            setTimeout(() => hideAndResolve(), 0);
            return 0;
          }
          return r - 1;
        });
      }, 1000);
    });
  };

  useEffect(() => {
    setWarmupHandler(showWarmup);
    return () => cleanupTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <WarmupContext.Provider value={{ isWarmingUp: visible, remaining, retryNow: hideAndResolve }}>
      {children}

      {visible && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: 16,
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 420,
              background: "#111827",
              color: "white",
              borderRadius: 12,
              padding: 18,
              boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
            }}
          >
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>
              Starting the service…
            </div>
            <div style={{ fontSize: 13, opacity: 0.9, marginBottom: 14, lineHeight: 1.4 }}>
              Render spins down inactive backends. We’re waking it up now — please wait{" "}
              <b>{remaining}s</b> and we’ll retry automatically.
            </div>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button
                onClick={hideAndResolve}
                style={{
                  background: "#0ea5e9",
                  border: "none",
                  color: "white",
                  padding: "10px 12px",
                  borderRadius: 10,
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Retry now
              </button>
            </div>
          </div>
        </div>
      )}
    </WarmupContext.Provider>
  );
};

